module.exports = __webpack_public_path__ + "img/架构图.81d8ec17.svg";